import styled from 'styled-components';
import CustomCard from '@components/CustomCard';

export const RequestMessagesCard = styled(CustomCard)`
  margin-top: 16px;

  .ant-list-items {
    padding: 16px;
    padding-bottom: 8px;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.shapes.borderRadius};
    background: ${({ theme }) => theme.colors.content};
  }

  .ant-list-header {
    padding: 0;
    border: none;
    margin-bottom: 16px;
    text-align: right;
  }

  .ant-list-item {
    padding: 0;
    border: none;
  }

  .list-items-group {
    display: flex;
    flex-direction: column;
    background: transparent !important;
    border: none !important;

    .ant-list-items {
      padding: 0;
      border: none;
      border-radius: 0;
    }

    > .ant-tag {
      margin: 16px 0;
      background: ${({ theme }) => theme.colors.background} !important;
    }

    .first-group-day-tag {
      margin-top: 0;
    }
  }
`;
